<template>
  <div class="dynamic__lists-container">
    <div class="dynamic-lists__wrapper" v-if="items.length > 0">
      <router-link
        :to="`/my/manage/dynamics/${item.id}`"
        tag="div"
        class="dynamic-lists__item mangeHover"
        v-for="item in items"
        :key="item.id"
      >
        <div class="item__manage" style="padding:0;top:50%;transform:translateY(-50%);">
          <div class="manage__item" @click.stop="onDelete(item.id)">
            <i class="icon icon-manage-delete"></i>
          </div>
        </div>
        <div class="item__img-groups">
          <template v-if="item.picture_urls.length > 0">
            <div class="groups__item" v-for="(img, i) in item.picture_urls" :key="i">
              <el-image :src="img | parseImage" fit="cover" class="img"></el-image>
            </div>
          </template>
        </div>
        <div class="item__text">
          <p class="text__created">{{ item.ctime | parseTime }}</p>
          <p class="text__summary">{{ item.content }}</p>
        </div>
      </router-link>
    </div>
    <Empty v-else hint="你还没有发布动态，让我们一起期待吧！"></Empty>
  </div>
</template>

<script>
import Empty from '@/pages/common/empty.vue';
import { myList as list } from '@/api/dynamic';

export default {
  components: {
    Empty,
  },
  data() {
    return {
      items: [],
    };
  },
  watch: {
    $route: 'init',
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit('openLoading');
      const res = await list();
      const dyLists = res.data.list;
      this.items = dyLists;
      this.$store.commit('closeLoading');
    },
    onDelete(id) {
      const that = this;
      that.$confirm('是否删除此条动态', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          const tempInstance = instance;
          if (action === 'confirm') {
            tempInstance.confirmButtonLoading = true;
            tempInstance.confirmButtonText = '删除中...';
            that.$http.post('html/User/myDynamicDel', {
              id,
            }).then(() => {
              tempInstance.confirmButtonLoading = false;
              that.$message({
                type: 'success',
                message: '删除成功',
              });
              that.items = that.items.filter((item) => Number(item.id) !== Number(id));
              done();
            });
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>

<style>
  .dynamic__lists-container {
    padding: 1.71875vw 0;
  }
</style>
